<template>
  <div class="sm-reports">
    <div class="sm-wrap lg">
      <reports-top 
        @requestCSV="reqCSV = true"
        @requestPDF="reqPDF = true"
      />
      <reports-main 
        v-if="provider.client_level"
        :reqCSV="reqCSV"
        :reqPDF="reqPDF"
        @finishCSV="reqCSV = false"
        @finishPDF="reqPDF = false"

      />
    </div>

    <!-- <div class="sm-reports__sales-btn">
      <button
        v-if="(
          (
            provider.client_level == 2 || 
            provider.client_level == 3
          ) && 
          userAccount.role == 'manager' &&
          currentTab != 'sales'
        )"
        type="button"
        class="sm-btn sm-btn--small"
        @click="openSalesReport"
      >Sales report</button>
    </div> -->
  </div>
</template>

<script>
import Top from '@/views/admin/pages/reports/Top.vue';
import Main from '@/views/admin/pages/reports/Main.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'reports',
  components: {
    'reports-top': Top,
    'reports-main': Main,
  },
  data() {
    return {
      reqCSV: false,
      reqPDF: false,
    };
  },
  computed: {
    ...mapGetters({
      provider: 'provider',
      userAccount: 'account/userAccount'
    }),
    currentTab() {
      return this.$route.query.tab;
    }
  },
  methods: {
    openSalesReport() {
      this.$router.push({
        query: {
          tab: 'sales'
        }
      })
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/common/reports/_reports.scss';
</style>
